import React, { createContext, useContext, useMemo, useState } from "react";

interface FormState {
  pending: boolean;
}

const FormContext = createContext<FormState | undefined>(undefined);

export function useFormContext() {
  return useContext(FormContext);
}

export function Form({
  children,
  onSubmit,
  className,
}: {
  children?: React.ReactNode;
  onSubmit?: () => void | Promise<unknown>;
  className?: string;
}) {
  const [pending, setPending] = useState(false);
  const contextValue = useMemo(() => ({ pending }), [pending]);

  return (
    <FormContext.Provider value={contextValue}>
      <form
        className={className}
        noValidate
        onSubmit={async (event) => {
          event.preventDefault();
          event.stopPropagation();

          if (pending) {
            return;
          }

          if (event.currentTarget.checkValidity()) {
            try {
              setPending(true);
              await onSubmit?.();
            } finally {
              setPending(false);
            }
          }
        }}
      >
        {children}
      </form>
    </FormContext.Provider>
  );
}
